module.exports = __webpack_public_path__ + "static/californian-cafe-showcase-26f7b7700010a59b2567d09cd3411ca9.jpeg";